import React from "react";
import { useForm } from "react-hook-form";
import { CLOTH_TYPE_CONFIG_URL } from "../../../../api/api_routing_urls";
import useAuth from "../../../../authentication/hooks/useAuth";
// import useAxiosPrivate from "../../../../authentication/hooks/useAxiosPrivate";
import axios from "../../../../api/axios";
import AddButton_v2 from "../../../../reusable-components/buttons/AddButton_v2";
import Button from "../../../../reusable-components/buttons/Button";
import SubmitButton from "../../../../reusable-components/buttons/SubmitButton";
import Input from "../../../../reusable-components/inputs/InputTextBox/Input";
import { button, cancel_button } from "../../../../theme/lightTheme";
import showToast from "../../../../utilities/notification/NotificationModal";

const AddClothTypeForm = ({
  getClothTypeList,
  editClothTypeDetails,
  setEditClothTypeDetails,
  setShowAddForm,
}) => {
  // const axiosPrivate = useAxiosPrivate();
  // const { auth } = useAuth();

  const isEdit = Object.keys(editClothTypeDetails)?.length > 0;

  const defaultValues = {
    wear_type_id: !isEdit ? "" : editClothTypeDetails?.wear_type_id,
    cloth_type_name: !isEdit ? "" : editClothTypeDetails?.cloth_type_name,
  };
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    setError,
    clearErrors,
    reset,
    setValue,
  } = useForm({
    mode: "onChange",
    defaultValues: defaultValues,
    criteriaMode: "all",
    shouldFocusError: true,
    shouldUnregister: true,
  });

  const onSubmit = async (data) => {
    try {
      let response = "";
      if (!isEdit) {
        // data.createdby = auth.userid;
        data.createdby = "admin";
        response = await axios.post(CLOTH_TYPE_CONFIG_URL, data);
      } else {
        // data.updatedby = auth.userid;
        data.updatedby = "admin";
        data.cloth_type_id = editClothTypeDetails?.cloth_type_id;
        response = await axios.post(`${CLOTH_TYPE_CONFIG_URL}/update`, data);
      }

      // console.log({ response });

      if (response.status === 200) {
        if (isEdit) {
          setEditClothTypeDetails({});
          showToast(
            "Cloth Type details has been updated successfully.",
            "success"
          );
        } else {
          showToast(
            "Cloth Type details has been added successfully.",
            "success"
          );
        }
        getClothTypeList();
      } else {
        if (isEdit) {
          console.log("Save Cloth Type Details Error:", response.data);
        } else {
          if (
            response.data.saveClothTypeDetails.includes("unique_cloth_type")
          ) {
            showToast(
              "Cloth type already exists. Cannot insert duplicate cloth type.",
              "error"
            );
          } else {
            showToast(
              "Whoops!!!! This doesn't feel right. There might be an issue. Please contact the administrator.",
              "error"
            );
          }
        }
        return;
      }
      setShowAddForm(false);
      reset();
    } catch (error) {
      if (!error?.response) {
        showToast("No Server Response", "error");
      } else if (error.response.status === 422) {
        showToast("Some of the required inputs were not provided.", "error");
      } else {
        showToast(
          "Whoops!!!! This doesn't feel right. There might be an issue. Please contact the administrator.",
          "error"
        );
      }
    }
  };

  return (
    <section>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Input
          defaultName="wear_type_id"
          register={register}
          name="Wear Type ID"
          required={true}
          pattern={null}
          errors={errors}
          placeholder="Enter wear type id"
          setError={setError}
          clearError={clearErrors}
          autoComplete="off"
          type="text"
          classes={`rounded-lg px-3 py-2 text-sm w-full focus:outline-none focus:ring-0 focus:border-2 focus:border-black`}
          onChangeInput={null}
          defaultValue={defaultValues.wear_type_id}
          setValue={setValue}
        />
        <Input
          defaultName="cloth_type_name"
          register={register}
          name="Cloth Type Name"
          required={true}
          pattern={null}
          errors={errors}
          placeholder="Enter cloth type name"
          setError={setError}
          clearError={clearErrors}
          autoComplete="off"
          type="text"
          classes={`rounded-lg px-3 py-2 text-sm w-full focus:outline-none focus:ring-0 focus:border-2 focus:border-black`}
          onChangeInput={null}
          defaultValue={defaultValues.cloth_type_name}
          setValue={setValue}
        />
        <div className="flex justify-between">
          <SubmitButton
            isSubmitting={isSubmitting}
            label={!isEdit ? "Submit" : "Update"}
            className={button}
          />
          <Button
            onClick={() => {
              setEditClothTypeDetails({});
              setValue("waer_type_id", "");
              setValue("cloth_type_name", "");
              setShowAddForm(false);
            }}
            aria-label="Cancel Cloth Type Update Button"
            className={cancel_button}
          >
            Cancel
          </Button>
        </div>
      </form>
    </section>
  );
};

export default AddClothTypeForm;
